import NProgress from 'nprogress';

let active = 0;

function startProgress() {
    if (active === 0) {
        NProgress.start();
    }

    active++;
}

function stopProgress() {
    active--;

    if (active === 0) {
        NProgress.done();
    }
}

export {
    startProgress,
    stopProgress,
};
